import { Dispatch } from "redux"
import { TInfoMessage, EAppAction, TAppAction } from "../../types"


export const setInfoMessageAction = (payload?: TInfoMessage) => {
    return async (dispatch: Dispatch<TAppAction>) => {
        dispatch({
            type: EAppAction.SET_INFO_MESSAGE,
            payload
        })
    }
}

export const setTokenAction = (payload?: string) => {
    return async (dispatch: Dispatch<TAppAction>) => {
        dispatch({
            type: EAppAction.SET_TOKEN,
            payload
        })
    }
}